import React, { ReactNode } from 'react';
import styles from './Notification.module.scss';
import { ReactComponent as ErrorIcon } from '../../../assets/icons/error.svg';
import { ReactComponent as SuccessIcon } from '../../../assets/icons/success.svg';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info.svg';
import cn from 'classnames';

export interface ErrorLinkProps {
  href: string;
  text: string;
}
interface NotificationProps {
  message: string;
  caption?: string;
  link?: ErrorLinkProps;
}
export const ErrorNotification = (props: NotificationProps) => {
  return <Notification icon={<ErrorIcon className={styles.icon} />} {...props} />;
};

export const SuccessNotification = (props: NotificationProps) => {
  return <Notification icon={<SuccessIcon className={styles.icon} />} {...props} />;
};

export const InfoNotification = (props: NotificationProps) => {
  return <Notification icon={<InfoIcon className={styles.icon} />} {...props} />;
};

interface BasicNotificationProps extends NotificationProps {
  icon?: ReactNode;
  className?: string;
}
function Notification(props: BasicNotificationProps) {
  const { message, className, icon, caption, link } = props;
  return (
    <div className={cn(styles.notification, className)}>
      <div className={styles.alert}>
        <div className={styles.icon}>{!!icon && icon}</div>
        <span className={styles.message}>{message}</span>
      </div>
      <div className={styles.extra}>
        {caption && <span className={styles.caption}>{caption}</span>}
        {link && (
          <a className={styles.link} href={link.href}>
            {link.text}
          </a>
        )}
      </div>
    </div>
  );
}
